import type { BaseOrder } from '#domain/BaseOrder.ts';
import type { Stop } from '#domain/Stop.ts';

const canonicalServiceOrderTypes = [
    'cleaning',
    'parking',
    'fueling',
    'charging',
    'assembly',
    'tour-start',
    'tour-end',
] as const;

export const legacyServiceOrderTypes = ['fueling-or-charging'] as const;
export const selectableServiceOrderTypes = [...canonicalServiceOrderTypes, 'other'] as const;
export const serviceOrderTypes = [...selectableServiceOrderTypes, ...legacyServiceOrderTypes] as const;

export type ServiceOrderCategory = (typeof serviceOrderTypes)[number];
export type SelectableServiceOrderType = (typeof selectableServiceOrderTypes)[number];

export type ServiceOrder = BaseOrder & {
    type: 'service';
    executionStop: Stop;
    description: string;
    category?: ServiceOrderCategory;
    company?: string;
    note?: string;
};
